/**
 * Analytics Event Tracking
 * Tracks listing funnel events for conversion optimization
 */
import apiClient from './api';

const trackEvent = async (eventName, metadata = {}) => {
  try {
    await apiClient.post('/analytics/event', {
      event_name: eventName,
      listing_type: metadata.listing_type || null,
      step: metadata.step || null,
      metadata,
    });
  } catch {
    // Silent fail - analytics should never block UX
  }
};

export const trackListingFormStarted = (listingType) =>
  trackEvent('listing_form_started', { listing_type: listingType });

export const trackListingStepCompleted = (listingType, step) =>
  trackEvent('listing_step_completed', { listing_type: listingType, step });

export const trackListingSubmitted = (listingType) =>
  trackEvent('listing_submitted', { listing_type: listingType });

export const trackListingAbandoned = (listingType, lastStep) =>
  trackEvent('listing_abandoned', { listing_type: listingType, step: lastStep });

export default trackEvent;
